import { keyframes } from '@emotion/react';
import { Heading, HeadingProps } from '@hover/blueprint';
import { forwardRef } from '@hover/blueprint/chakra';
import React from 'react';

interface AnimatedHeaderProps extends HeadingProps {
  animationStep: number;
}

const STEP_MULTIPLIER = 1.15;

const animation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
`;

const AnimatedHeader = forwardRef<AnimatedHeaderProps, 'h1'>(
  ({ animationStep, ...props }, ref) => (
    <Heading
      opacity={0}
      position="absolute"
      sx={{
        animationFillMode: 'forwards',
        animationName: animation.toString(),
        animationDuration: '1.5s',
        animationDelay: `${(animationStep - 1) * STEP_MULTIPLIER}s`,
      }}
      transform="translateY(100%)"
      {...props}
      ref={ref}
    />
  ),
);

export { AnimatedHeader };
